import React from 'react';
import { Text } from '../../components';
import { Button } from '@kmx/legos-react-button';
import SuccessGraphic from './images/success-graphic';
import RequestType from '../constants/request-types';


class SuccessPage extends React.Component {
  constructor(props) {
    super(props);
    
  }

  render() {
      let message = '';
      let showSpecialFooter = false;
      
        switch(this.props.requestType) {
            //presently, all "on behalf" requests get the same success message
          case RequestType.DiscloseBehalf:
          case RequestType.DeleteBehalf:
          case RequestType.CorrectBehalf:
          case RequestType.AppealBehalf:
            message = 'Your request on behalf of someone else has been received.  If we have any questions, we will email you at the email address you provided.';
            break;
          case RequestType.Disclose:
            message = 'If we have personal information about you, CarMax will disclose your data to you within 45 days.  We will send you an email with a link to the information.  The email will be sent to the  email address your provided.  We will let you know if it may take longer.'
            break;
          case RequestType.Delete:
            message = 'While we are permanently deleting or removing your personal information in some instances, in others we will be de-identifying and/or aggregating your personal information.  If CarMax has personal information about you, we will honor your deletion request within 45 days.  We will send you an email at the email address you provided informing you when your request for deletion of your personal information has been completed.   We will let you know if it may take longer.'
            showSpecialFooter = true;
            break;
          case RequestType.Correct:
            message = 'Your request to correct information has been received.  should we have any  questions about your request, we will contact you via email at the email address first provided.  We will respond via email when we\'ve completed your request or if we have to deny any part of your request, in which case we will provide vie email that reasoning for such denial.';
            break;
          case RequestType.Appeal:
            message = 'We have received your appeal request.  We will email you at the email address you provided when we have reviewed your request .';
            break;
        }

      return (
        <div className='data-final text-center'>
          <SuccessGraphic />
          <Text.Display5 className='data-final-element'>Success!</Text.Display5>
          <Text.Body2 className='data-final-element'>{message}</Text.Body2>
          <Button
            className='m-t-l p-l-xxl p-r-xxl data-final-element'
            full={true}
            level='primary'
            type='button'
            onClick={() => {
              window.location.href = '/privacy-policy';
            }}>
            Return to Privacy Policy
          </Button>
          {showSpecialFooter ? <div className='record-warning text-center m-t-xl data-final-element'>
              *In response to your deletion request, we may retain certain information as permitted by law. For example, we may retain
              information to complete open transactions, fulfill warranties, process recalls, detect and protect against security threats or
              illegal activity, exercise or defend our legal rights, comply with legal obligations, or for internal recordkeeping and research
              purposes that are consistent with the circumstances in which we collected the information.
            </div> : null}
        </div>
      );
      }
    }

export default SuccessPage;
